import { render, staticRenderFns } from "./BlockedCartForm.vue?vue&type=template&id=6e21b2a7&scoped=true&"
import script from "./BlockedCartForm.vue?vue&type=script&lang=ts&"
export * from "./BlockedCartForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21b2a7",
  null
  
)

export default component.exports